import { render, staticRenderFns } from "./HelpingHand.vue?vue&type=template&id=7f8d25d6&"
import script from "./HelpingHand.vue?vue&type=script&lang=js&"
export * from "./HelpingHand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports